export default "__VITE_ASSET__DPPKd5xG__"